var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 16.6667H18.3334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3821 7.81237L10.5487 2.7082C10.2345 2.43329 9.76541 2.43329 9.45123 2.7082L3.61789 7.81237C3.43705 7.97061 3.33331 8.19921 3.33331 8.43951V15.8332C3.33331 16.2935 3.70641 16.6665 4.16665 16.6665H7.49998C7.96022 16.6665 8.33331 16.2935 8.33331 15.8332V12.4999C8.33331 12.0396 8.70641 11.6665 9.16665 11.6665H10.8333C11.2936 11.6665 11.6666 12.0396 11.6666 12.4999V15.8332C11.6666 16.2935 12.0397 16.6665 12.5 16.6665H15.8333C16.2935 16.6665 16.6666 16.2935 16.6666 15.8332V8.43951C16.6666 8.19921 16.5629 7.97061 16.3821 7.81237Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.e95ad511.svg";
export { ForwardRef as ReactComponent };